import api from './api';
import SessionStorageService from './sessionStorage';

const PORTAL_ACCESS_LOGIN_KEY = 'portal-access-login';

/**
 * Marks that the customer has just logged in, so the next portal
 * check is made with the "login" trigger.
 */
export const markPortalAccessLogin = () => {
  SessionStorageService.set(PORTAL_ACCESS_LOGIN_KEY, true);
};

/**
 * The portal applies different rules when the customer has just logged in
 * ("login") or was already logged in and only opened the platform ("access").
 */
const consumePortalAccessTrigger = () => {
  if (SessionStorageService.get(PORTAL_ACCESS_LOGIN_KEY)) {
    SessionStorageService.delete(PORTAL_ACCESS_LOGIN_KEY);
    return 'login';
  }

  return 'access';
};

/**
 * Returns the client portal link when the customer must complete
 * the registration, otherwise (or in case of failure) returns null.
 */
export const getPortalAccessLink = async (returnUrl) => {
  try {
    const { data } = await api.get('/lovable/portal/access-link', {
      params: { return_url: returnUrl, trigger: consumePortalAccessTrigger() }
    });

    return data.url || null;
  } catch (error) {
    // eslint-disable-next-line
    console.error(error.message);
    return null;
  }
};
